import { OptionsType } from "@helpers/baseDataConvert";

export const convertVendorsToSelect = (data: any) => {
  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label = item?.vendorName;
      selectOptions.value = item?.id;

      convertedData.push(selectOptions);
    });

  return convertedData;
};
